import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Number$MAX_SAFE_INTEGER from "@babel/runtime-corejs2/core-js/number/max-safe-integer";
import _Number$MIN_SAFE_INTEGER from "@babel/runtime-corejs2/core-js/number/min-safe-integer";
import _parseFloat from "@babel/runtime-corejs2/core-js/parse-float";
import _Number$isNaN from "@babel/runtime-corejs2/core-js/number/is-nan";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classnames from 'classnames';
import { polyfill } from 'react-lifecycles-compat';
import { isFunction } from '@utiljs/is';
var focused = false;
var NumberReg = /^[/+|-]?(\d*)(\.\d*)?$/;

var InputNumber = /*#__PURE__*/function (_React$Component) {
  _inherits(InputNumber, _React$Component);

  var _super = _createSuper(InputNumber);

  function InputNumber() {
    var _this;

    _classCallCheck(this, InputNumber);

    _this = _super.apply(this, arguments);
    _this.precision = 0; // eslint-disable-next-line react/state-in-constructor

    _this.state = {
      value: _this.props.value || _this.props.defaultValue || _this.getDefaultValue()
    };
    /**
     * 仅负责通过校验后的设值
     */

    _this.setValue = function (value) {
      if (_this.state.value === value) return;

      _this.setState({
        value: value
      });

      var onChange = _this.props.onChange;

      if (isFunction(onChange)) {
        onChange(value);
      }
    }; // eg: '1.' '+'  '-'


    _this.isNotCompleteNumber = function (num) {
      return (// @ts-ignore
        _Number$isNaN(num) || num && num.toString().indexOf('.') === num.toString().length - 1 || /^[+-]$/.test(num)
      );
    }; // string型number 转 number


    _this.toNumber = function (num) {
      if (_this.isNotCompleteNumber(num)) {
        return num;
      }

      if (_this.props.precision !== undefined) {
        return _this.toPrecision(num);
      }

      if (num === '') return _this.getDefaultValue();
      return Number(num);
    };

    _this.toNumberWhenInput = function (num) {
      if (/\.\d*0$/.test(num) || num.length > 16) {
        return num;
      }

      return _this.toNumber(num);
    };

    _this.handleIncrease = function () {
      if (_this.props.disabled || _this.props.readOnly) return;

      var maxPrecision = _this.getMaxPrecision();

      var factor = _this.getPrecisionFactor(); // @ts-ignore


      var nextValue = (_this.state.value * factor + (_this.props.step || 1) * factor) / factor;

      _this.setValue(_this.checkValue(nextValue.toFixed(maxPrecision)));
    };

    _this.handleDecrease = function () {
      if (_this.props.disabled || _this.props.readOnly) return;

      var maxPrecision = _this.getMaxPrecision();

      var factor = _this.getPrecisionFactor(); // @ts-ignore


      var nextValue = (_this.state.value * factor - (_this.props.step || 1) * factor) / factor;

      _this.setValue(_this.checkValue(nextValue.toFixed(maxPrecision)));
    };

    _this.handleChange = function (e) {
      var _this$props = _this.props,
          parser = _this$props.parser,
          formatter = _this$props.formatter;
      var value = e.target.value.trim();

      if (isFunction(formatter) && isFunction(parser)) {
        value = parser(value);
      }

      var stateV = _this.state.value;
      var onChange = _this.props.onChange;

      var InputVal = _this.toNumberWhenInput(value);

      var realValue = NumberReg.test(value) ? InputVal : stateV; // 以此判断是否为受控组件

      if (_this.props.value === undefined) {
        // 非受控输入过程可能出现包含运算符的非法值，先允许输入在 blur 时进行校验
        if (!/^[/+|-]?(\d*)(\.\d*)?$/.test(value)) {
          // @ts-ignore
          value = stateV;
        }

        _this.setState({
          value: value
        });
      }

      if (isFunction(onChange)) {
        onChange(realValue);
      }
    };

    _this.handleFocus = function () {
      focused = true;
    };

    _this.handleBlur = function () {
      // 输入过程可能出现非法值，先进性输入，在 blur 时进行校验
      var checkValue = _this.getDefaultValue();

      if (_this.state.value !== '') {
        checkValue = Number(_this.state.value);
      }

      if (checkValue !== '' && _Number$isNaN(checkValue)) {
        // 当输入值不是 Number 类型 初始化输入框
        checkValue = _this.props.defaultValue || _this.getDefaultValue();
      }

      if (_this.props.precision !== undefined) {
        checkValue = _this.toPrecision(checkValue);
      }

      focused = false;

      _this.setValue(_this.checkValue(checkValue));
    };

    return _this;
  }

  _createClass(InputNumber, [{
    key: "getDefaultValue",
    value: function getDefaultValue() {
      var isForceToZeroWhenEmpty = this.props.isForceToZeroWhenEmpty;
      return isForceToZeroWhenEmpty ? 0 : '';
    }
    /**
     * 仅针对数值来做最大最小值校验
     * 输入过程中非数值不校验
     */

  }, {
    key: "checkValue",
    value: function checkValue(value) {
      if (value === '') return '';
      var validVal = value;
      var max = this.props.max === 0 ? 0 : this.props.max || Infinity;
      var min = this.props.min === 0 ? 0 : this.props.min || -Infinity;

      if (validVal >= max) {
        validVal = max;
      }

      if (validVal <= min) {
        validVal = min;
      }

      return this.toPrecision(validVal);
    }
    /**
     * 格式化精度
     */

  }, {
    key: "toPrecision",
    value: function toPrecision(num) {
      var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.precision;
      if (num === '') return '';

      if (this.props.precision === undefined) {
        return Number(num);
      }

      return _parseFloat(Number(num).toFixed(precision));
    }
    /**
     * 精度乘数
     * 用来避免小数计算的误差
     * @param precesion
     */

  }, {
    key: "getPrecisionFactor",
    value: function getPrecisionFactor() {
      var maxPrecision = this.getMaxPrecision();
      return Math.pow(10, maxPrecision);
    }
  }, {
    key: "getMaxPrecision",
    value: function getMaxPrecision() {
      var value = this.state.value;
      var valuePrecision = this.getPrecision(value);
      var stepPrecision = this.getPrecision(this.props.step || 1);
      return Math.max(valuePrecision, stepPrecision);
    }
    /**
     * 获取精度
     */

  }, {
    key: "getPrecision",
    value: function getPrecision(value) {
      if (this.props.precision !== undefined) return this.props.precision;
      var valueString = value.toString();
      var dotPosition = valueString.indexOf('.');
      var precision = 0;

      if (dotPosition !== -1) {
        precision = valueString.length - dotPosition - 1;
      }

      return precision;
    }
    /**
     * 根据值进行判断增减按钮状态
     */

  }, {
    key: "disableBtn",
    value: function disableBtn(value) {
      var max = this.props.max;
      if (max === undefined) max = Infinity;
      var min = this.props.min;
      if (min === undefined) min = -Infinity;
      return {
        increase: value >= max,
        decrease: value <= min
      };
    }
  }, {
    key: "render",
    value: function render() {
      var stateValue = this.state.value;

      var _this$disableBtn = this.disableBtn(Number(stateValue)),
          increase = _this$disableBtn.increase,
          decrease = _this$disableBtn.decrease;

      var _this$props2 = this.props,
          step = _this$props2.step,
          size = _this$props2.size,
          value = _this$props2.value,
          defaultValue = _this$props2.defaultValue,
          disabled = _this$props2.disabled,
          readOnly = _this$props2.readOnly,
          editable = _this$props2.editable,
          showOperator = _this$props2.showOperator,
          vertical = _this$props2.vertical,
          formatter = _this$props2.formatter,
          style = _this$props2.style,
          className = _this$props2.className,
          placeholder = _this$props2.placeholder;
      this.precision = Math.max(this.getPrecision(step || 1), this.getPrecision(value || defaultValue || 0));
      var inputValue = stateValue;

      if (isFunction(formatter)) {
        inputValue = formatter(stateValue);
      }

      return /*#__PURE__*/React.createElement("div", {
        className: classnames('form-control', 'roo-input-number', {
          'roo-input-lg': size === 'large',
          'roo-input-sm': size === 'small',
          'roo-input-xs': size === 'mini',
          'roo-input-number-no-operator': !showOperator,
          'roo-input-number-vertical': vertical,
          disabled: disabled || readOnly
        }, className),
        style: style
      }, showOperator && /*#__PURE__*/React.createElement("span", {
        className: classnames('input-number-operator', 'decrease', {
          disabled: decrease
        }),
        onClick: this.handleDecrease
      }), showOperator && /*#__PURE__*/React.createElement("span", {
        className: classnames('input-number-operator', 'increase', {
          disabled: increase
        }),
        onClick: this.handleIncrease
      }), /*#__PURE__*/React.createElement("input", {
        type: "text",
        autoComplete: "off",
        placeholder: placeholder,
        value: inputValue,
        disabled: disabled,
        readOnly: readOnly || !editable,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      // 受控模式通过 focused 控制是默认赋值更新还是 onChang 更新
      // 由于 setState 设置会引起该方法更新，导致 nextProps.value 无法判断，故 focused 不能挂载在 state
      var value = nextProps.value,
          max = nextProps.max,
          min = nextProps.min;

      if (value !== undefined) {
        if (!focused) {
          if (value > max) {
            return {
              value: max
            };
          }

          if (value < min) {
            return {
              value: min
            };
          }
        }

        return {
          value: value
        };
      }

      return null;
    }
  }]);

  return InputNumber;
}(React.Component);

InputNumber.rooName = 'RInputNumber';
InputNumber.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  precision: PropTypes.number,
  isForceToZeroWhenEmpty: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  editable: PropTypes.bool,
  vertical: PropTypes.bool,
  parser: PropTypes.func,
  placeholder: PropTypes.string,
  formatter: PropTypes.func,
  size: PropTypes.oneOf(['large', 'normal', 'small', 'mini']),
  onChange: PropTypes.func,
  showOperator: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string
};
InputNumber.defaultProps = {
  value: undefined,
  defaultValue: 0,
  precision: undefined,
  isForceToZeroWhenEmpty: true,
  min: _Number$MIN_SAFE_INTEGER,
  max: _Number$MAX_SAFE_INTEGER,
  placeholder: undefined,
  step: 1,
  disabled: false,
  readOnly: false,
  editable: true,
  vertical: false,
  size: 'normal',
  parser: null,
  formatter: null,
  onChange: function onChange() {},
  showOperator: true,
  style: undefined,
  className: undefined
}; // @ts-ignore

polyfill(InputNumber);
export default InputNumber;